import { HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { FileSelectEvent, FileUploadEvent } from 'primeng/fileupload';
import { Media } from 'src/app/modules/entities/media';
import { Person } from 'src/app/modules/entities/person';
import { MediaService } from 'src/app/modules/services/media.service';
import { environment } from 'src/environments/environment.development';
import { url } from 'src/app/modules/util/constants';

interface UploadResponse {
  file: File;
  status: string;
  message: string;
  url: string;
}
interface FileExtended {
  objectURL: {
    changingThisBreaksApplicationSecurity: string;
  }
}

@Component({
  selector: 'app-media-upload',
  templateUrl: './media-upload.component.html',
  styleUrls: ['./media-upload.component.css']
})
export class MediaUploadComponent implements OnInit {

  constructor(private router: Router, private fb: FormBuilder, private messageService: MessageService, private cd: ChangeDetectorRef, private mediaService: MediaService) {
    const navigation = this.router.getCurrentNavigation();
    this.message = navigation?.extras.state?.['message'];
    this.person = navigation?.extras.state?.['person'];
  }

  steps: MenuItem[] | undefined;
  files: UploadResponse[] = [];
  selectedFiles: any[] = [];
  message: string = "";
  uploadUrl: string = environment.cfgApiBaseUrl + '/upload';
  fileReferences: Media[] = [];
  person: Person;
  isFirstUpload: boolean = true;
  loading: boolean = false;
  loadingFinal: boolean = false;

  ngOnInit() {
    if (this.person === undefined)
      this.router.navigate([url['registro-1']]);
    this.steps = [
        {
            label: 'Contacto',
            routerLink: '/' + url['registro-1']
        },
        {
            label: 'Descripción',
            routerLink: '/' + url['registro-2']
        },
        {
            label: 'Multimedia',
            routerLink: '/' + url['carga-imagenes']
        }
    ];
  }

  ngAfterViewInit() {
    if (this.message !== undefined && this.message !== '') {
      this.messageService.add({
        severity: "info",
        detail: this.message
      });
    }
    this.cd.detectChanges();
  }

  endRegistration() {
    this.loadingFinal = true;
    if (this.isFirstUpload) {
      let index = 0;
      while (this.fileReferences[index].type === '.mp4') {
        index++;
      }
      this.fileReferences[index].isProfile = 1;
      this.isFirstUpload = false;
    }
    this.mediaService.saveMediaBulk(this.fileReferences).subscribe(response=> {
      if (response.status === 'success') {
        let extras = {};
        if (this.person.city.searchName !== 'bogota' && this.person.city.searchName !== 'medellin') {
          extras = { queryParams: { 'long-message': true } };
        }
        this.router.navigate([url['registro-fin']], extras);
      }
    });
  }

  onBeforeUpload() {
    this.loading = true;
  }

  onUpload(event: FileUploadEvent) {
    let i = 0;
    if ((event.originalEvent as HttpResponse<any>).body[i].status === 'success') {
      for (let file of event.files) {
        let message: string = (event.originalEvent as HttpResponse<any>).body[i].status === 'success' 
          ? 'La imagen se cargó correctamente.' 
          : 'Error al cargar el archivo ' + file.name + '. ' + (event.originalEvent as HttpResponse<any>).body[i].message;
        this.files.push({
          file: file,
          status: (event.originalEvent as HttpResponse<any>).body[i].status,
          message: message,
          url: ((file as unknown) as FileExtended).objectURL.changingThisBreaksApplicationSecurity
        });
        this.messageService.add({
          severity: (event.originalEvent as HttpResponse<any>).body[i].status,
          detail: message
        });
        this.fileReferences.push({
          id: undefined,
          fileName: (event.originalEvent as HttpResponse<any>).body[i].data.filename,
          filePath: (event.originalEvent as HttpResponse<any>).body[i].data.filepath,
          type: (event.originalEvent as HttpResponse<any>).body[i].data.type,
          isProfile: 0,
          uploadDate: new Date(Date.parse((event.originalEvent as HttpResponse<any>).body[i].data.uploadDate)),
          order: i + 1,
          visible: 1,
          person: Number(this.person.idperson),
          views: 0
        });
        i++;
      }
    } else {
      this.messageService.add({
        severity: (event.originalEvent as HttpResponse<any>).body[i].status,
        summary: 'Error cargando el archivo.',
        detail: (event.originalEvent as HttpResponse<any>).body[i].message
      });
    }
    this.loading = false;
  }

  removeImage(index: number) {
    this.files.splice(index, 1);
    this.fileReferences.splice(index, 1);
  }

}
